import clsx from 'clsx';
import React, { HTMLAttributes } from 'react';

import styles from './ChartTooltip.module.scss';

export const ChartTooltipLabel = ({
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement>) => (
  <span className={clsx(styles.label, className)} {...props} />
);
